import { ComponentHelper } from "../../core/util/componentHelper";
import { TextBox } from "../../core/components/textBox"
import { Button, ButtonProps } from "../../core/components/button"
import { Config } from "../../core/config/config";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { General } from "../../../siteManagement/general";
import { Sheet, SheetEventType } from "../../../siteManagement/sheet";
import { BaseComponentProps } from "./baseComponentProps";
import { Entity } from "./commonApp";
import React from "react";

export default class GroupingTextBox extends React.Component<GroupingTextBoxProps, any>{
    private factory = ComponentHelper.createFactory();
    private readOnly: boolean = null;

    private buttonStyle: React.CSSProperties = {
        borderColor: "#ced4da",
        borderLeft: "none"
    }

    constructor(props) {
        super(props);
        Helper.getTranslations(["WebSMS.ResourcePlanning.GroupingShow", "WebSMS.ResourcePlanning.GroupingSelect"]);       
    }

    private setValue = (value: number) => {
        this.props.onChange(this.props.field, value);
        this.setState({});
    }

    private renderTextBox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.props.value;
        props.disabled = true;
        return (
            <>
                <TextBox {...props}/>
            </>
        );
    }

    private getNewGroupId = async () => {
        const result = await HTTPService.noBusyIndicator().get<JsonResultClass<number>>("ResourcePlanning/GetNextGroupId");
        if (result.Code == 0) {
            this.setValue(result.Data)
        } else {
            NotificationHelper.showErrorMessage(result.Message)
        }
    }

    private renderAddButton = () => {
        const props: ButtonProps = {
            handleClick: this.getNewGroupId,
            iconName: "plus",
            buttonStyle: this.buttonStyle,
            title: Config.translations.newLabel,
            readOnly: this.readOnly
        }
        return (
            <>
                <Button {...props}/>
            </>
        );
    }

    private renderRemoveButton = () => {
        const props: ButtonProps = {
            handleClick: () => {
                this.setValue(null);
            },
            iconName: "trash-alt",
            title: Config.translations.deleteLabel,
            buttonStyle: this.buttonStyle,
            readOnly: this.readOnly
        }
        return (
            <>
                <Button {...props} />
            </>
        );
    }

    private search = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl("DynamicSearch/Window/AssignmentGrouping?fullObject=true");
        sheet.bind(SheetEventType.RowClicked, (dataItem) => {
            const value = Helper.getAttributeSavely(dataItem, "gruppierung");
            if (Helper.hasValue(value))
                this.setValue(value);
        })
    }

    private renderSearchButton = () => {
        const props: ButtonProps = {
            handleClick: this.search,
            readOnly: this.readOnly,
            iconName: "search",
            title: Helper.getTranslation("WebSMS.ResourcePlanning.GroupingSelect"),
            buttonStyle: this.buttonStyle
        }
        return (
            <>
                <Button {...props} />
            </>
        );
    }

    private handleVBClick = () => {
        const url = "ResourcePlanning/ResourcePlanningGroupingList";
        const titleEx = General.Sheet.Manager.getTopMostSheet().getTitle();

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, { "grouping": this.props.value, "projNr": this.props.entity.ProjNr, "pIndex": this.props.entity.PIndex, "title": titleEx }, null, true);
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.setState({});
        });
    }
   
    private renderViewButton = () => { 
        const props: ButtonProps = {
            handleClick: this.handleVBClick,
            title: Helper.getTranslation("WebSMS.ResourcePlanning.GroupingShow"),
            readOnly: this.readOnly || !Helper.hasValue(this.props.value) || this.props.value == 0,
            iconName: "fal fa-layer-group",
            buttonStyle: this.buttonStyle
        }
        return (
            <>
                <Button {...props} />
            </>
        );
    }


    render() {
        this.readOnly = !this.props.entity.RecordRight.CanWrite;
      
        const viewBtn = Helper.hasValue(this.props.entity.ProjNr) && Helper.hasValue(this.props.entity.PIndex) ? this.renderViewButton() : null;

        return (
            <div className="grouping-text-box">
                {this.renderTextBox()}
                {this.renderAddButton()}
                {this.renderSearchButton()}
                {this.renderRemoveButton()}
                {viewBtn}
            </div>
        );
    }
}

interface GroupingTextBoxEntity extends Entity {
    ProjNr?: string;
    PIndex?: number;
}

interface GroupingTextBoxProps extends BaseComponentProps{
    value: number;
    entity?: GroupingTextBoxEntity;
}